import { useCookie } from '#imports'

// In the web layer, this is just a wrapper around useCookie.
// In capacitor layer(s), this will use the native secure storage.
export function useSecureState<T = string | null>(name: string): { state: Ref<T>, initialize: () => Promise<void> } {
  const cookieOptions = {
    secure: !import.meta.dev, // Disable secure cookies in development for Safari.
    watch: true,
  }
  return { state: useCookie(name, cookieOptions), initialize: () => Promise.resolve() }
}
